import { InputRule, Node } from "@tiptap/core"
import { renderMathToHTML } from "../lib/math"

export const MATH_INLINE_NODE = "mathInline"

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    mathInline: {
      insertMathInline: (attrs?: { latex?: string }) => ReturnType
    }
  }
}

export const MathInline = Node.create({
  name: MATH_INLINE_NODE,
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: element => element.getAttribute("data-latex") ?? "",
      },
      emailImageUrl: {
        default: null,
        rendered: false,
      },
      emailImageWidth: {
        default: null,
        rendered: false,
      },
      emailImageHeight: {
        default: null,
        rendered: false,
      },
    }
  },

  parseHTML() {
    return [{ tag: `span[data-type="${MATH_INLINE_NODE}"]` }]
  },

  renderHTML({ node }) {
    const latex = node.attrs.latex
    return [
      "span",
      {
        "data-type": MATH_INLINE_NODE,
        "data-latex": latex,
        class: "math-inline",
      },
      latex ? renderMathToHTML({ latex, displayMode: false }) : latex,
    ]
  },

  addCommands() {
    return {
      insertMathInline:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { latex: attrs.latex ?? "" },
          })
        },
    }
  },

  addInputRules() {
    return [
      new InputRule({
        find: /\$([^$]+)\$$/,
        handler: ({ state, range, match }) => {
          const latex = match[1]
          if (!latex) return
          const { tr } = state
          const node = state.schema.nodes[MATH_INLINE_NODE]?.create({
            latex,
          })
          if (node) {
            tr.replaceWith(range.from, range.to, node)
          }
        },
      }),
    ]
  },
})
